import { lazy } from "react";
import Loadable from "app/components/Loadable";

const SaasPlanAdminPage = Loadable(lazy(() => import("./SaasPlanAdminPage")));

const SaasPlanAdminRoutes = [
  {
    path: "/admin/saas-subscriptions/plans",
    element: <SaasPlanAdminPage />,
  },
];

export default SaasPlanAdminRoutes;
